import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import {
  upadtetradingExpiryStatus,
  gettradingExpiry,
} from "../../../Service/user.service";
import Swal from "sweetalert2";
import toast from "react-hot-toast";


const Setting = () => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const [settings, setSettings] = useState({
    exitTime: "",
  });

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = async () => {
    try {
      const data = { _id: user_details?.user_id };
      const response = await gettradingExpiry(data);
      if (response?.status) {
        setSettings({
          exitTime: response.data?.trading_expiry || "",
        });
      }
    } catch (error) {
      console.error("Error fetching status:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        _id: user_details?.user_id,
        status: settings.exitTime,
      };

      const response = await upadtetradingExpiryStatus(data);
      if (response.status) {
        toast.success("Settings updated successfully!");
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  return (
    <Content Page_title={"Settings"} button_status={false}>
      <div className="container mt-4">
        <h4 className="mb-3 fw-bold">Trading Preferences</h4>
        <form onSubmit={handleSubmit} className="row g-4">
          <div className="col-md-6">
            <label className="form-label">Default Trading Off Time</label>
            <select
              className="form-select"
              name="exitTime"
              value={settings.exitTime}
              onChange={handleChange}
              required
            >
              {/* <option value="">Select Exit Time</option> */}

       
              <option value="never_off">Trading Never Off</option>

              {Array.from({ length: 24 }, (_, i) => {
                const hour = String(i).padStart(2, "0");
                return (
                  <option key={i} value={`${hour}:00`}>
                    {hour}:00
                  </option>
                );
              })}
            </select>

          </div>

          <div className="col-12">
            <button type="submit" className="btn btn-primary px-4">
              Save Settings
            </button>
          </div>
        </form>
      </div>
    </Content>
  );
};

export default Setting;
